<ng-container>
  <div class="page__nav">
    <app-back-button
      [text]="'Tilbage'"
      [altLink]="'/foraeldreloese'"
      [altText]="'Partneroprettet overblik'"
      idparameter="unParentedId"
    ></app-back-button>

    @if (unparentedAccounting) {
      <div class="data">
        <div class="data__lbl">Bemærkning til servicerapport</div>
        <div class="data__val">
          {{ unparentedAccounting.remarkToServicereport }}
        </div>
      </div>
    }
    @if (unparentedAccounting) {
      <div class="data">
        <div class="data__lbl">Partner</div>
        <div class="data__val">
          {{ unparentedAccounting.partner?.name }}
        </div>
      </div>
    }
    <div class="page__nav-bottom"></div>
  </div>
  <div class="topbar topbar--has-submenu">
    <div class="contract-state">
      @if (!hasBeenMatched) {
        <mat-icon>merge_type</mat-icon>
        Skal matches
      }
      @if (hasBeenMatched) {
        <ng-container class="green">
          <mat-icon>check</mat-icon>
          Er matchet
        </ng-container>
      }
    </div>
    <div>
      <button class="btn-icon red-cancel align-center" type="button" matTooltip="Afvis ordren" (click)="rejectOrdre()">
        <mat-icon svgIcon="delete"></mat-icon>
        <span>Afvis ordren</span>
      </button>
    </div>
    @if (unparentedAccounting) {
      <div
        class="timestamp"
        title="Ordre oprettet {{ unparentedAccounting.deliveryDate | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}"
        >
        <strong>Oprettet:&nbsp;</strong>
        {{ unparentedAccounting.deliveryDate | amLocale: 'da' | amCalendar: { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}
      </div>
    }
    @if (showUnknownKundeNrError) {
      <div>
        <span class="orange">
          <strong>Advarsel:</strong>
          Serviceaftalen med Ok Kunde Aftalenr: {{ unparentedAccounting.okKundeAftalenr }} kunne ikke findes i EGIS
        </span>
      </div>
    }
    <div class="topbar__actions">
      <div>
        @if (!searchQuery && !hasBeenMatched) {
          <span class="nomatch-warning green">
            <span>Find og match</span>
            <mat-icon>arrow_forward</mat-icon>
          </span>
        }
      </div>
      @if (!hasBeenMatched) {
        <app-search [searchString]="searchQuery" label="Find serviceaftale"></app-search>
      }
      @if (hasBeenMatched) {
        <button mat-raised-button (click)="unmatchServiceAftale()">Fortryd match</button>
        <div class="split-button">
          <button
            mat-flat-button
            color="primary"
            (click)="saveUnparentedOrdre(false)"
            [disabled]="!unparentedOrdreForm.valid || !this.canMatch"
            >
            Gem og luk
          </button>
          <button [matMenuTriggerFor]="menu" mat-flat-button color="primary" [disableRipple]="true" [disabled]="!unparentedOrdreForm.valid">
            <mat-icon svgIcon="arrow-small"></mat-icon>
          </button>
          <span class="split-button__gfx"></span>
          <mat-menu #menu="matMenu" xPosition="before" class="split-button__menu">
            <button mat-menu-item (click)="saveUnparentedOrdre(true)" [disabled]="!this.canMatch">Gem, godkend og luk</button>
          </mat-menu>
        </div>
      }
    </div>
  </div>

  <div class="page__content page__content--has-submenu contract contract--details orders--list">
    @if (unparentedAccounting) {
      @if (searchQuery && !hasBeenMatched) {
        <h2>Fundne serviceaftaler</h2>
      }
      @if (hasBeenMatched) {
        <h2>Matchet serviceaftale</h2>
      }
      @if (searchQuery && serviceaftaler?.length == 0) {
        <span class="nomatch-warning red">
          <mat-icon svgIcon="obs-solid"></mat-icon>
          Ingen aftaler fundet - lav en ny søgning
        </span>
      }
      @if ((searchQuery && serviceaftaler?.length > 0) || hasBeenMatched) {
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="mat-elevation-z2"
          >
          <ng-container matColumnDef="Serviceabonnement.Produkt">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let serviceaftale">
              <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="ServiceaftaleState">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let serviceaftale">
              <mat-icon [matTooltip]="serviceaftale.serviceaftaleState.text" [svgIcon]="getStatusIcon(serviceaftale)"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="kundenr">
            <th mat-header-cell *matHeaderCellDef>Kundenr</th>
            <td mat-cell *matCellDef="let serviceaftale">
              @if (serviceaftale.kunde) {
                <div>{{ serviceaftale.kunde ? serviceaftale.kunde.okKundeNr : '' }}</div>
              }
              @if (!serviceaftale.kunde) {
                <div>
                  <span matTooltip="Ingen data i G4">N/A</span>
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="OkKundeAftaleNr">
            <th mat-header-cell *matHeaderCellDef>Aftalenr</th>
            <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.okKundeAftaleNr }}</td>
          </ng-container>
          <ng-container matColumnDef="kundeNavn">
            <th mat-header-cell *matHeaderCellDef>Navn</th>
            <td mat-cell *matCellDef="let serviceaftale">
              {{ serviceaftale.kunde ? serviceaftale.kunde.anlaegsadresse?.name : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="adresse">
            <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
            <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.kunde ? serviceaftale.kunde.anlaegsadresse?.adressLine : '' }}</td>
          </ng-container>
          <ng-container matColumnDef="telefon">
            <th mat-header-cell *matHeaderCellDef>Telefonnr.</th>
            <td mat-cell *matCellDef="let serviceaftale">
              {{ serviceaftale.kunde ? ($safeNavigationMigration(serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber) : '' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Ajourtid">
            <th mat-header-cell *matHeaderCellDef>Senest ændret</th>
            <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.modifiedOn | date: 'shortDate' }}</td>
          </ng-container>
          <ng-container matColumnDef="Oprettid">
            <th mat-header-cell *matHeaderCellDef>Oprettet</th>
            <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.createdOn | date: 'shortDate' }}</td>
          </ng-container>
          <ng-container matColumnDef="rowActions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let serviceaftale" (click)="$event.stopPropagation()" class="align-right">
              @if (!hasBeenMatched) {
                <button mat-raised-button color="primary" (click)="matchToServiceAftale(serviceaftale)">
                  Match aftalen
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick(row)"
            [class.active]="globalActiveRowID == row.id"
          ></tr>
        </table>
      }
      <div class="flex-wrap flex-wrap--flex-start margin-bottom-x2">
        <div class="flex-wrap__col flex-wrap__col--40 margin-top-x2">
          <h2>Ordren</h2>
          <div class="card">
            <form [formGroup]="unparentedOrdreForm" autocomplete="off">
              <div class="data">
                <div class="data__lbl">Bookingnr.</div>
                <div class="data__val">
                  <h2>
                    {{ unparentedAccounting.bookingId }}
                  </h2>
                </div>
              </div>
              <div class="data">
                <div class="data__subrow">
                  <div class="data__lbl">Opgave</div>
                  <div class="data__val">
                    <mat-radio-group class="vertical-radio-group" formControlName="opgaveTypeId">
                      @for (opgaveType of opgaveTyper; track opgaveType) {
                        <mat-radio-button [value]="opgaveType.id">
                          {{ opgaveType.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="data__subrow">
                  <div class="data__lbl">Deadline</div>
                  <div class="data__val">
                    <mat-form-field appearance="outline">
                      <mat-datepicker-toggle matPrefix [for]="deadlinePicker"></mat-datepicker-toggle>
                      <input #deadlineInput matInput [matDatepicker]="deadlinePicker" formControlName="deadline" />
                      <mat-datepicker #deadlinePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="flex-wrap__col flex-wrap__col--60 margin-top-x2 nolimits">
          <h2>Posteringer</h2>
          @if (unparentedAccounting.afregningslinjer) {
            <app-posterings-list
              [posteringsLinjer]="unparentedAccounting.afregningslinjer"
              [editable]="false"
            ></app-posterings-list>
          }
          @if (!unparentedAccounting.afregningslinjer) {
            <span>Der er ingen posteringer på ordren</span>
          }
        </div>
      </div>
    }
  </div>
</ng-container>

@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="selectedaftale"></app-quickview>
    <div class="quick-view__bottom">
      <a class="blue" [routerLink]="['/aftale', selectedaftale.okKundeAftaleNr]">Åben aftalen</a>
      <button mat-raised-button color="primary" (click)="matchToServiceAftale(selectedaftale)">Match aftalen</button>
    </div>
  </div>
}
